<script>
  import BaseImage from "@/components/partials/BaseImage.vue";
  import mixin from "../mixin";

  export default {
    components: {
      BaseImage,
    },

    mixins: [mixin],

    data() {
      return {};
    },

    computed: {
      campaign() {
        return this.notification.content.campaign;
      },
      couponRequest() {
        return this.notification.content.couponRequest;
      },
    },

    methods: {
      setFilters() {
        const filtersData = this.storageFiltersData;

        if (this.$router.currentRoute.name === "campaign-coupons") {
          this.$store.dispatch("Globals/restAdvancedFilters");
        }

        filtersData["campaign-coupons"] = {};

        this.setLocalStorage("filters", filtersData);
        this.viewCampaignCoupons();
      },
    },
  };
</script>
<template>
  <div class="d-flex align-items-center">
    <div class="img-container m-r-12">
      <BaseImage
        :src="campaign.logo"
        width="40"
        height="40"
        class="radius-full cursor-pointer fitted-img"
        :name="`notification-img-${notification.id}`"
      />
    </div>
    <div class="m-r-15">
      <p
        class="p-base-medium text-neutral-400 m-b-9"
        :class="{ 'cursor-pointer': canViewCoupons }"
        @click="setFilters"
      >
        <span class="text-neutral-900 m-r-3">{{
          couponRequest.allocatedCount
        }}</span>
        <span class="m-r-3">{{
          $t(`notifications.${notification.type}.${"coupon-code"}`)
        }}</span>
        <span class="text-neutral-900 m-r-3">{{ campaign.name }}</span>
        <span>{{
          $t(`notifications.${notification.type}.${"got-allocated"}`)
        }}</span>
        <template v-if="notification.content.startDate">
          <span class="m-r-3">{{ $t(`notifications.${notification.type}.${"starting-from"}`) }}</span>
          <span class="text-neutral-900 m-r-3">{{ notification.content.startDate }}</span>
        </template>
      </p>
    </div>
  </div>
</template>
<style scoped lang='sass'></style>
